import { EndCustomerDto } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { OperationDTO } from '../../operations/dto/operations.dto';
import { Operations } from '../../operations/operations.entity';
import { ProductConversion } from '../product-conversion.entity';
import { ProductConversionRequestDto } from './product-conversion.request.dto';
@Injectable()
export class ProductConversionAdapter {
 
  /**
   * 
   * @param productConvDTO 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(productConvDTO: ProductConversionRequestDto,  isUpdate: boolean = false ): ProductConversion {
    const prodConv = new ProductConversion();
    prodConv.productConversionId=productConvDTO.productConversionId;
    prodConv.conversionReason=productConvDTO.conversionReason;
    prodConv.fromOperation=productConvDTO.fromOperation;
    prodConv.toOperation=productConvDTO.toOperation;
    prodConv.fromSaleOrder=productConvDTO.fromSaleOrder;
    prodConv.toSaleOrder=productConvDTO.toSaleOrder;
    prodConv.fromSaleOrderItemId=productConvDTO.fromSaleOrderItemId;
    prodConv.toSaleOrderItemId=productConvDTO.toSaleOrderItemId;
    prodConv.lotCode=productConvDTO.lotCode;
    prodConv.remarks=productConvDTO.remarks;
    prodConv.quantity = productConvDTO.quantity;
    prodConv.prodInvId = productConvDTO.prodInvId;
    prodConv.plantId = productConvDTO.plantId;
    prodConv.convertedProdInvId = productConvDTO.convertedProdInvId;
    prodConv.boxes = productConvDTO.boxes;
    prodConv.isActive=productConvDTO.isActive==undefined?true:productConvDTO.isActive;
    if (isUpdate) {
        prodConv.updatedUser = productConvDTO.updatedUser;
    } else {
        prodConv.isActive = true;
        prodConv.createdUser = productConvDTO.createdUser;
    }
    return prodConv;
  }
  
  
  public convertEntityToDto(prodConvObject: ProductConversion): ProductConversionRequestDto {
    const productConvDTO = new ProductConversionRequestDto;
    productConvDTO.productConversionId = prodConvObject.productConversionId;
    productConvDTO.fromOperation = prodConvObject.fromOperation;
    productConvDTO.toSaleOrder = prodConvObject.toSaleOrder;
    productConvDTO.fromSaleOrder = prodConvObject.fromSaleOrder;
    productConvDTO.toSaleOrder = prodConvObject.toSaleOrder;
    productConvDTO.conversionReason = prodConvObject.conversionReason;
    productConvDTO.lotCode = prodConvObject.lotCode;
    productConvDTO.quantity = prodConvObject.quantity;
    productConvDTO.remarks = prodConvObject.remarks;
    productConvDTO.plantId = prodConvObject.plantId;
    productConvDTO.prodInvId = prodConvObject.prodInvId;
    prodConvObject.convertedProdInvId = prodConvObject.convertedProdInvId
    prodConvObject.boxes = prodConvObject.boxes
    productConvDTO.isActive = prodConvObject.isActive;
    productConvDTO.createdAt = prodConvObject.createdAt;
    productConvDTO.updatedAt = prodConvObject.updatedAt;
    productConvDTO.createdUser = prodConvObject.createdUser;
    productConvDTO.updatedUser = prodConvObject.updatedUser;
    productConvDTO.versionFlag = prodConvObject.versionFlag;
    return productConvDTO;
  }
}
